import { usePromiseTracker } from 'react-promise-tracker'
import Loader from 'react-loader-spinner';
import styled from 'styled-components'

function LoadingIndicator(props:any) {
    const {promiseInProgress} = usePromiseTracker()
    return ( promiseInProgress ?
    <LoadingDiv>
      <Loader type="ThreeDots" color="#AEBBC6" height="100" width="100" />
    </LoadingDiv>
    :
    <span></span>
    )
}

const LoadingDiv = styled.div`
    display:flex;
    width:100%;
    justify-content:center;
`

export default LoadingIndicator
